import { render, staticRenderFns } from "./warehouse-add-quick.vue?vue&type=template&id=190e2c80&scoped=true&"
import script from "./warehouse-add-quick.vue?vue&type=script&lang=js&"
export * from "./warehouse-add-quick.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190e2c80",
  null
  
)

export default component.exports